<section class="design">
    <svg class="design_svg">
      <text  fill="white" x="37%" y="90px">{{ 'design.webMobile' | transloco }}</text>
      <text  fill="white"x="76%" y="250px">{{ 'design.userExperience' | transloco }}</text>
      <text  fill="white" x="-23%" y="250px" class="design_svg_movile">{{ 'design.responsive' | transloco }}</text>
      <text  fill="white" x="-25%" y="275px" class="design_svg_movile">{{ 'design.development' | transloco }}</text>
      <text  fill="white" x="2%" y="250px" class="design_svg_tablet">{{ 'design.responsive' | transloco }}</text>
      <text  fill="white" x="2%" y="275px" class="design_svg_tablet">{{ 'design.development' | transloco }}</text>
      <text  fill="white" x="6%" y="250px" class="design_svg_desktop">{{ 'design.responsive' | transloco }}</text>
      <text  fill="white" x="5%" y="275px" class="design_svg_desktop">{{ 'design.development' | transloco }}</text>
      <text  fill="white" x="4%" y="250px" class="design_svg_landscape">{{ 'design.responsive' | transloco }}</text>
      <text  fill="white" x="2%" y="275px" class="design_svg_landscape">{{ 'design.development' | transloco }}</text>
      <text  fill="white" x="69%" y="360px">{{ 'design.brandIdentity' | transloco }}</text>
      <text  fill="white" x="20%" y="435px">{{ 'design.prototyping' | transloco }}</text>
      <circle  cx="33%" cy="88" fill="white" r="7" stroke="none"></circle>
      <circle  cx="30%" cy="165" fill="white" r="5" stroke="none"></circle>
      <circle  cx="84%" cy="220" fill="white" r="7" stroke="none"></circle>
      <circle  cx="28%" cy="250" fill="white" r="7" stroke="none"></circle>
      <circle  cx="80%" cy="320" fill="white" r="7" stroke="none"></circle>
      <circle  cx="50%" cy="340" fill="white" r="5" stroke="none"></circle>
      <circle  cx="30%" cy="400" fill="white" r="7" stroke="none"></circle>
      <circle  cx="115%" cy="100" fill="white" r="7" stroke="none"></circle>
      <line  stroke="white" stroke-width="0.5" x1="33%" x2="30%" y1="88px" y2="165px"></line>
      <line  stroke="white" stroke-width="0.5" x1="30%" x2="84%" y1="165" y2="220"></line>
      <line  stroke="white" stroke-width="0.5" x1="84%" x2="28%" y1="220" y2="250"></line>
      <line  stroke="white" stroke-width="0.5" x1="30%" x2="28%" y1="165" y2="250"></line>
      <line  stroke="white" stroke-width="0.5" x1="28%" x2="50%" y1="250px" y2="340"></line>
      <line  stroke="white" stroke-width="0.5" x1="30%" x2="50%" y1="400px" y2="340"></line>
      <line  stroke="white" stroke-width="0.5" x1="80%" x2="50%" y1="320" y2="340"></line>
      <line  stroke="white" stroke-width="0.5" x1="84%" x2="115%" y1="220" y2="100"></line> 
    </svg>
</section>
